import { render, staticRenderFns } from "./user-icon.vue?vue&type=template&id=25a05dca"
import script from "./user-icon.vue?vue&type=script&lang=js"
export * from "./user-icon.vue?vue&type=script&lang=js"
import style0 from "./user-icon.vue?vue&type=style&index=0&id=25a05dca&prod&lang=scss"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports